import { Button, intl } from 'ehs-react';
import React from 'react';

export function OtpContinueButton({
  onContinueClick,
  disabled = true
}: Readonly<{
  onContinueClick: () => void;
  disabled?: boolean;
}>): React.JSX.Element {
  return (
    <div className="content-button-bar">
      <Button
        scale={'medium'}
        onClick={onContinueClick}
        text={intl('patientSelfOnboardingPortlet.welcomeScreen.buttonStartNow')}
        variant="primary"
        disabled={disabled}
        data-testid="otp-continue-button"
      />
    </div>
  );
}
